import React from 'react';
import Card from '../Card';

const AudienceCardSkeleton: React.FC = () => {
  return (
    <Card className="p-0 border border-gray-100 overflow-hidden animate-pulse" fullWidth>
      <div className="flex flex-col md:flex-row">
        {/* Left Column - Header & Primary Info */}
        <div className="p-5 md:w-1/3 bg-gradient-to-br from-gray-50 to-white border-r border-gray-100">
          {/* Title skeleton */}
          <div className="h-7 bg-gray-200 rounded-md w-3/4 mb-2 shimmer"></div>

          {/* Date skeleton */}
          <div className="flex items-center mb-4">
            <div className="w-4 h-4 bg-gray-200 rounded mr-2"></div>
            <div className="h-4 bg-gray-200 rounded w-32 shimmer"></div>
          </div>

          {/* Core Stats */}
          <div className="space-y-3">
            {/* Total Profiles skeleton */}
            <div className="bg-white rounded-md p-3 flex items-center shadow-sm">
              <div className="h-10 w-10 rounded-full bg-gray-200 mr-3 shimmer"></div>
              <div>
                <div className="h-3 bg-gray-200 rounded w-20 mb-1"></div>
                <div className="h-5 bg-gray-200 rounded w-12 shimmer"></div>
              </div>
            </div>

            {/* Segments skeleton */}
            <div className="bg-white rounded-md p-3 flex items-center shadow-sm">
              <div className="h-10 w-10 rounded-full bg-gray-200 mr-3 shimmer"></div>
              <div>
                <div className="h-3 bg-gray-200 rounded w-16 mb-1"></div>
                <div className="h-5 bg-gray-200 rounded w-8 shimmer"></div>
              </div>
            </div>

            {/* Industry skeleton */}
            <div className="bg-white rounded-md p-3 flex items-center shadow-sm">
              <div className="h-10 w-10 rounded-full bg-gray-200 mr-3 shimmer"></div>
              <div>
                <div className="h-3 bg-gray-200 rounded w-16 mb-1"></div>
                <div className="h-3 bg-gray-200 rounded w-24 shimmer"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Detailed Info */}
        <div className="p-5 md:w-2/3 flex flex-col">
          <div className="flex-1">
            {/* Industry Segments header skeleton */}
            <div className="mb-5">
              <div className="flex items-center mb-3 pb-2 border-b border-gray-100">
                <div className="w-4 h-4 bg-gray-200 rounded mr-2"></div>
                <div className="h-5 bg-gray-200 rounded w-32 shimmer"></div>
              </div>

              {/* Segments grid skeleton */}
              <div className="bg-gray-50 p-3 rounded-md">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  {[1, 2, 3, 4].map((i) => (
                    <div
                      key={i}
                      className="flex justify-between items-center bg-white p-1.5 rounded border border-gray-100"
                    >
                      <span className="h-3 bg-gray-200 rounded w-24 shimmer"></span>
                      <span className="h-4 bg-gray-200 rounded-full w-8"></span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Business Description skeleton */}
            <div className="col-span-2">
              <div className="h-4 bg-gray-200 rounded w-40 mb-2"></div>
              <div className="bg-gray-50 p-3 rounded-md border border-gray-100 space-y-2">
                <div className="h-3 bg-gray-200 rounded w-full shimmer"></div>
                <div className="h-3 bg-gray-200 rounded w-5/6 shimmer"></div>
                <div className="h-3 bg-gray-200 rounded w-4/6 shimmer"></div>
              </div>
            </div>
          </div>

          {/* Select Button skeleton */}
          <div className="mt-5 hidden md:block">
            <div className="h-10 bg-gray-200 rounded-md w-full shimmer"></div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default AudienceCardSkeleton;
